import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@carnica/ui-kit';
import { IconArrowsRight } from '@carnica/graphics';
import { Metric } from "../../../../../../metric";
import { MenuUrlTarget } from "../../../../../../types";
import style from "./styles.pcss";
var cn = classNames.bind(style);
var IconArrowsRightModified = function IconArrowsRightModified(params) {
  return /*#__PURE__*/React.createElement(IconArrowsRight, _extends({}, params, {
    className: cn('arrow-icon'),
    color: "white"
  }));
};
export var NavigationItem = function NavigationItem(_ref) {
  var _navigation$navigatio;
  var navigation = _ref.navigation,
    activeTab = _ref.activeTab,
    activeCategory = _ref.activeCategory,
    withIndent = _ref.withIndent;
  return /*#__PURE__*/React.createElement("li", {
    className: cn('navigation-item'),
    key: navigation.title
  }, /*#__PURE__*/React.createElement("div", null, navigation.title && /*#__PURE__*/React.createElement(Text, {
    className: cn('navigation-item__title'),
    color: "tertiary-invert",
    size: "xs"
  }, navigation.title), /*#__PURE__*/React.createElement("div", {
    className: cn('nested-items', {
      'nested-items--with-indent': withIndent && !navigation.title
    })
  }, navigation === null || navigation === void 0 ? void 0 : (_navigation$navigatio = navigation.navigationItems) === null || _navigation$navigatio === void 0 ? void 0 : _navigation$navigatio.map(function (_ref2) {
    var title = _ref2.title,
      url = _ref2.url,
      isBlankUrlTarget = _ref2.isBlankUrlTarget;
    return /*#__PURE__*/React.createElement(Metric, {
      asChild: true,
      data: JSON.stringify({
        link: title,
        tab: activeTab === null || activeTab === void 0 ? void 0 : activeTab.title,
        section: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title
      }),
      events: {
        headerMetric: ['handleNavTabLinkClick']
      },
      key: title,
      mode: "click"
    }, /*#__PURE__*/React.createElement(Button, {
      className: cn('link'),
      href: url || undefined,
      mode: "inline",
      tagName: "a",
      target: MenuUrlTarget.get(isBlankUrlTarget)
    }, /*#__PURE__*/React.createElement(Text, {
      className: cn('link__text'),
      color: navigation.highlighted ? 'primary-invert' : 'secondary-invert',
      key: title,
      lineHeight: navigation.highlighted ? 26 : 20,
      size: navigation.highlighted ? 's' : 'xs'
    }, title)));
  }))), navigation.url && navigation.urlTitle && /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      link: navigation.urlTitle,
      tab: activeTab === null || activeTab === void 0 ? void 0 : activeTab.title,
      section: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title
    }),
    events: {
      headerMetric: ['handleNavTabLinkClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('navigation-item__primary-link'),
    href: navigation.url,
    iconRight: IconArrowsRightModified,
    iconRightView: "background",
    mode: "inline",
    tagName: "a",
    target: MenuUrlTarget.get(navigation.isBlankUrlTarget)
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('navigation-item__primary-link-text'),
    color: "secondary",
    size: "xs"
  }, navigation.urlTitle))));
};